import { render, staticRenderFns } from "./ResidentialHomePage.vue?vue&type=template&id=19072f84&scoped=true&"
import script from "./ResidentialHomePage.vue?vue&type=script&lang=js&"
export * from "./ResidentialHomePage.vue?vue&type=script&lang=js&"
import style0 from "./ResidentialHomePage.vue?vue&type=style&index=0&id=19072f84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19072f84",
  null
  
)

export default component.exports